module.exports = __webpack_public_path__ + "assets/checkmark-21fd4776aec6ea2d7bb29993147ea488.svg";